// this is a temporary store for large amounts of data using uniquely keyed values
// works like a globally accesible useState (it survives automatic component pulldown)
// but is also intended to be temporary/cleared entirely periodically
// also not in the redux store as it could/may be replaced under the hood by indexDB
import { useState } from 'react';
let dataStore = new Map();
const getValue = uniquekey => () => dataStore.get(uniquekey);
export const useTempStorage = uniquekey => {
  const [value, setValue] = useState(getValue(uniquekey));
  const setTempValue = uniquekey => newValue => {
    dataStore.set(uniquekey, newValue);
    setValue(newValue);
  };
  return [value, setTempValue(uniquekey)];
};
export const clearTempStorage = uniquekey => {
  if (uniquekey) {
    dataStore.delete(uniquekey);
  } else {
    dataStore = new Map();
  }
};
export { dataStore };